import {gql} from '@apollo/client';
import {useMutation} from '@apollo/client/react';
import {
  EtsyBulkCreateGdriveFileItemInput,
  MutationCreateQueueJobArgs,
  QueueJob,
  QueueJobInput,
} from '../__generated__/resolvers-types';

export const SET_ETSY_BULK_CREATE_GDRIVE_FILE_MUTATION = gql`
  mutation CreateQueueJob($job: QueueJobInput!) {
    createQueueJob(job: $job) {
      id
      status
      expireTimestamp
      creationTimestamp
      lastUpdateTimestamp
      etsyBulkCreateGdriveFile {
        shopRecordId
        template
        gdriveUrl
        imageFolder
        productFolder
        items {
          id
          name
          status
          error
        }
      }
    }
  }
`;

/**
 * bulk upload etsy product where each folder is a product
 * @returns
 */
export default function useSetEtsyBulkCreateGdriveFile() {
  const [createBulkEtsyGdriveFileJob, {data, loading, error}] = useMutation<QueueJob, MutationCreateQueueJobArgs>(
    SET_ETSY_BULK_CREATE_GDRIVE_FILE_MUTATION,
  );

  return {
    createBulkEtsyGdriveFileJob: (
      shopRecordId: string,
      url: string,
      template: string,
      imageFolder: string,
      productFolder: string,
      items: EtsyBulkCreateGdriveFileItemInput[],
    ) => {
      const job: QueueJobInput = {
        etsyBulkCreateGdriveFile: {
          shopRecordId,
          gdriveUrl: url,
          template,
          imageFolder,
          productFolder,
          items,
        },
      };
      return createBulkEtsyGdriveFileJob({
        variables: {job},
      });
    },
    data,
    loading,
    error,
  };
}
